export interface TransferModelResponse {
    predictions: TransferModel;
}
export interface TransferModel {
    score: string;
    esitoSemaforico: TrafficLightOutcome;
}

export enum TrafficLightOutcome {
    greenLight = 'Semaforo Verde',
    yellowLight = 'Semaforo Giallo',
    redLight = 'Semaforo Rosso',
    unknown = 'Non Disponibile',
    error = 'error',
}
